import {useQuery} from 'react-query';
import {getDomaineInfo} from '../Api/api';
import {DomainName} from '../Types/service';

export const useGetDomain = (customer: string, domaineName: string) => {
  return useQuery<any, any, DomainName | null>(
    ['domain', customer, domaineName],
    async () => getDomaineInfo(customer, domaineName),
    {enabled: !!customer}
  );
};
